'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLocation = updateLocation;

var _types = require('./types');

var _types2 = require('shared/redux/middlewares/geocoding/types');

function updateLocation(location) {
  return function (dispatch) {
    dispatch({
      type: _types2.GEOCODE_LOCATION,
      location: location
    });
    dispatch({
      type: _types.UPDATE_LOCATION,
      location: location
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/UpdateLocation/actions.js
// module id = 1275
// module chunks = 0